import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { RetailerTiersService } from './retailer-tiers.service';

@Component({
  selector: 'app-retailer-tiers',
  templateUrl: './retailer-tiers.component.html',
  styleUrls: ['./retailer-tiers.component.scss']
})
export class RetailerTiersComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {

  ngOnInit(): void {
    super.ngOnInit()
  }

  ngOnDestroy(){
    super.ngOnDestroy()
  }


}
